<template>
  <b-nav-item-dropdown
    v-if="activityLogList"
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="activityLogList.length"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <!-- {{ bellNotifications }} -->
        <b-badge pill variant="light-primary"> {{ bellNotifications.length }} New</b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="scrollable-container media-list scroll-area" tagname="li">
      <!-- Account Notification -->
      
      <div v-for="(notItem, index) in bellNotifications" :key="index">
      <!-- <b-link v-for="(notItem, index) in notifications" :key="index"> -->
        <!-- {{ notItem }} -->
        <!-- <div class="row">
          <div class="col">
            <h5>
              {{ notItem.msg }}
            </h5>
            <small class="notification-text">{{ notItem.subject }}</small>
            <span class="badge badge-pill bg-secondary pull-right">Mark as read</span>
          </div>
        </div> -->
        <b-media>
          <p class="media-heading">
            <router-link :to="notItem.url"><span class="font-weight-bolder">{{ notItem.msg }}</span></router-link>
          </p>
          <div class="row">
            <div class="col">
              <small class="notification-text">{{ notItem.subject }}</small>
            </div>
            <div class="col-md-4 text-right">
              <span class="btn btn-secondary btn-sm badge badge-pill" @click="notificationMarkAsRead(notItem.id)">Mark as read</span>
            </div>
          </div>
        </b-media>
      </div>
    </vue-perfect-scrollbar>

  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import RestApi, { studyPressBaseUrl } from '@/config/api_config'
import ModalBaseMasterList from '@core/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data () {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      activityLogList: JSON.parse(localStorage.getItem('activityLogList')),
    }
  },
  computed: {
    // activityLogList () {
    //   return this.$store.state.commonObj.activityLogList
    // }
    bellNotifications: function () {
      const Notifications = this.$store.state.bellNotifications
      // console.log('Notifications', Notifications)
      return Notifications
    }
  },
  created () {
    this.getNotificationData()
  },
  methods: {
    getNotificationData: async function () {
      
      try {

        this.loading = true
        const result = await RestApi.getData(studyPressBaseUrl, `/api/v1/ajax/get_notification_by_auth_user`)
        this.$store.dispatch('setBellNotifications', result.data.bellNotifications)
        this.loading = false

      } catch (error) {
        // this.errMsg(error)
        this.loading = false
      }
    },
    notificationMarkAsRead: async function (id) {
      
      try {
        this.loading = true
        const params = { id }
        const result = await RestApi.getData(studyPressBaseUrl, `/api/v1/ajax/notification_mark_as_read_by_user`, params)
        this.loading = false
        if (result.success) {
          this.getNotificationData()
        }

      } catch (error) {
        // this.errMsg(error)
        this.loading = false
      }
    },
    scrollHandle(evt) {
      console.log('evt', evt)
    }
  },
}
</script>

<style>

</style>
